import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'eyrus-reset-password-modal',
  templateUrl: './reset-password-modal.component.html',
  styleUrls: ['./reset-password-modal.component.sass']
})
export class EyrusSharedResetPasswordModalComponent implements OnInit {

  @Input() message: String = 'common.answerDelete';
  @Input() accept: String = 'common.yes';
  @Input() deny: String = 'common.no';
  @Input() email: String = '';

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {

  }

  ngOnInit() {
  }

  confirm() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
